module.exports = __webpack_public_path__ + "img/telemedecine2.f48c9724.webp";